import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { createLogger } from "redux-logger";

import { authReducer as auth } from "src/features/auth";
import { eventsReducer as events } from "src/features/events";
import { notificationsReducer as notifications } from "src/features/notifications";
import { patientReducer as patient } from "src/features/patient";

export const store = configureStore({
	reducer: combineReducers({ notifications, auth, patient, events }),
	middleware: getDefaultMiddleware => {
		if (process.env.NODE_ENV === "development") {
			return getDefaultMiddleware().concat(createLogger());
		}
		return getDefaultMiddleware();
	}
});

export type AppDispatch = typeof store.dispatch;
